module.exports = __webpack_public_path__ + "static/img/logo.03284775.png";